import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Redux Saga
import {
  GET_COUPONS_SUCCESS,
  GET_COUPONS_FAIL,
  GET_COUPON_SUCCESS,
  GET_COUPON_FAIL,
  CREATE_COUPON_SUCCESS,
  CREATE_COUPON_FAIL,
  UPDATE_COUPON_SUCCESS,
  UPDATE_COUPON_FAIL,
  DELETE_COUPON_SUCCESS,
  DELETE_COUPON_FAIL,
} from "./actionTypes"

// Coupons actions
import {
  getCoupons as getCouponsAction,
  getCoupon as getCouponAction,
} from "./actions"

// API functions
import {
  getCoupons,
  getCouponById,
  createCoupon,
  updateCoupon,
  deleteCoupon,
} from "../../helpers/backend_helper"

// Toast for notifications
import { toast } from "react-toastify"

// Get all coupons
function* fetchCoupons({ payload: { params, history } }) {
  try {
    const response = yield call(getCoupons, params)
    yield put({ type: GET_COUPONS_SUCCESS, payload: response })
  } catch (error) {
    yield put({ type: GET_COUPONS_FAIL, payload: error })
    toast.error("Failed to load coupons")
  }
}

// Get single coupon
function* fetchCoupon({ payload: { couponId, history } }) {
  try {
    const response = yield call(getCouponById, couponId)
    yield put({ type: GET_COUPON_SUCCESS, payload: response })
  } catch (error) {
    yield put({ type: GET_COUPON_FAIL, payload: error })
    toast.error("Failed to load coupon details")
  }
}

// Create coupon
function* onCreateCoupon({ payload: { coupon, history } }) {
  try {
    const response = yield call(createCoupon, coupon)
    yield put({ type: CREATE_COUPON_SUCCESS, payload: response })
    toast.success("Coupon created successfully!")
    // Refresh the coupons list
    yield put(getCouponsAction({ PageSize: 10, PageIndex: 0 }, history))
  } catch (error) {
    yield put({ type: CREATE_COUPON_FAIL, payload: error })
    toast.error("Failed to create coupon")
  }
}

// Update coupon
function* onUpdateCoupon({ payload: { couponId, coupon, history } }) {
  try {
    const response = yield call(updateCoupon, couponId, coupon)
    yield put({ type: UPDATE_COUPON_SUCCESS, payload: response })
    toast.success("Coupon updated successfully!")
    // Refresh the coupons list
    yield put(getCouponsAction({ PageSize: 10, PageIndex: 0 }, history))
  } catch (error) {
    yield put({ type: UPDATE_COUPON_FAIL, payload: error })
    toast.error("Failed to update coupon")
  }
}

// Delete coupon
function* onDeleteCoupon({ payload: { couponId, history } }) {
  try {
    const response = yield call(deleteCoupon, couponId)
    yield put({ type: DELETE_COUPON_SUCCESS, payload: response })
    toast.success("Coupon deleted successfully!")
    // Refresh the coupons list
    yield put(getCouponsAction({ PageSize: 10, PageIndex: 0 }, history))
  } catch (error) {
    yield put({ type: DELETE_COUPON_FAIL, payload: error })
    toast.error("Failed to delete coupon")
  }
}

// Watchers
function* getCouponsSaga() {
  yield takeEvery("GET_COUPONS", fetchCoupons)
}

function* getCouponSaga() {
  yield takeEvery("GET_COUPON", fetchCoupon)
}

function* createCouponSaga() {
  yield takeEvery("CREATE_COUPON", onCreateCoupon)
}

function* updateCouponSaga() {
  yield takeEvery("UPDATE_COUPON", onUpdateCoupon)
}

function* deleteCouponSaga() {
  yield takeEvery("DELETE_COUPON", onDeleteCoupon)
}

// Export all sagas
function* couponsSaga() {
  yield all([
    fork(getCouponsSaga),
    fork(getCouponSaga),
    fork(createCouponSaga),
    fork(updateCouponSaga),
    fork(deleteCouponSaga),
  ])
}

export default couponsSaga
